import { createFileRoute } from '@tanstack/react-router'
import { DetailingPage } from '../components/pages/DetailingPage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/detailing')({
  component: DetailingPage,
  head: () => publicPageHead({
    title: 'Car Detailing Geelong | Autoglow Detailing',
    description:
      'Tailored car detailing in Geelong and Drysdale — exterior detailing and premium detailing & enhancement after a complimentary inspection. Paint correction is on its own page.',
    path: '/detailing',
    ogTitle: 'Car Detailing Geelong | Autoglow Detailing',
    ogDescription: 'Tailored vehicle detailing from Autoglow in Drysdale, serving Geelong and the Bellarine.',
  }),
})
